import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuCalendarClock, LuX } from 'react-icons/lu';
import api from '../../services/api';

// Próximo mantenimiento sugerido (18-oct-2026): opcional. Lo pone el admin cuando corresponde
// (un service, no un arreglo suelto) y sale en el PDF del trabajo. Se guarda el mes.
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const mesTexto = (iso) => {
    if (!iso) return null;
    const [a, m] = String(iso).split('-').map(Number);
    return a && m ? `${MESES[m - 1]} ${a}` : null;
};
const enMeses = (n) => {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + n);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

export default function ProximoMantenimiento({ servicioId, valor, onCambio }) {
    const [abierto, setAbierto] = useState(false);
    const [mes, setMes] = useState('');
    const [guardando, setGuardando] = useState(false);
    const guardar = async (fecha) => {
        setGuardando(true);
        try {
            const r = await api.patch(`/servicios/${servicioId}/proximo-mantenimiento`, { fecha });
            onCambio(r.data.proximoMantenimiento);
            toast.success(fecha ? `Próximo mantenimiento: ${mesTexto(r.data.proximoMantenimiento)}` : 'Próximo mantenimiento quitado');
            setAbierto(false);
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); }
        finally { setGuardando(false); }
    };
    const chip = 'h-9 px-3 rounded-xl bg-chip text-label font-black text-ink active:scale-95 disabled:opacity-50';
    return (
        <div className="p-3.5 rounded-2xl bg-panel">
            <div className="flex items-center gap-2">
                <LuCalendarClock size={16} className="shrink-0 text-muted" />
                <p className="flex-1 min-w-0 text-caption">
                    <span className="font-bold text-muted">Próximo mantenimiento: </span>
                    <span className="font-black text-ink">{mesTexto(valor) || 'no se pone'}</span>
                </p>
                {valor && !abierto && (
                    <button type="button" onClick={() => guardar(null)} disabled={guardando} aria-label="Quitar"
                        className="w-8 h-8 rounded-lg flex items-center justify-center text-muted active:bg-chip"><LuX size={15} /></button>
                )}
                {!abierto && <button type="button" onClick={() => setAbierto(true)} className="h-8 px-2.5 rounded-lg bg-chip text-label font-black text-ink">{valor ? 'Cambiar' : 'Poner'}</button>}
            </div>
            {abierto && (
                <div className="mt-2.5 space-y-2">
                    <div className="flex flex-wrap gap-1.5">
                        <button type="button" disabled={guardando} onClick={() => guardar(enMeses(3))} className={chip}>En 3 meses</button>
                        <button type="button" disabled={guardando} onClick={() => guardar(enMeses(6))} className={chip}>En 6 meses</button>
                        <button type="button" disabled={guardando} onClick={() => guardar(enMeses(12))} className={chip}>En 1 año</button>
                    </div>
                    <div className="flex gap-1.5">
                        <input type="month" value={mes} onChange={e => setMes(e.target.value)} min={enMeses(0).slice(0, 7)}
                            className="flex-1 min-w-0 h-9 px-3 rounded-xl bg-chip text-ink text-caption outline-none" aria-label="Otro mes" />
                        <button type="button" disabled={!mes || guardando} onClick={() => guardar(`${mes}-01`)} className="h-9 px-3 rounded-xl bg-brand-red text-white text-label font-black disabled:opacity-40">Guardar</button>
                        <button type="button" onClick={() => setAbierto(false)} className="h-9 px-3 rounded-xl bg-chip text-label font-black text-secondary">Cancelar</button>
                    </div>
                    <p className="text-label text-muted">Solo si corresponde: en un arreglo suelto dejalo sin poner. Sale en el PDF del trabajo.</p>
                </div>
            )}
        </div>
    );
}
